import React, {useState} from "react";
import {Accordion, AccordionTab} from 'primereact/accordion';
import {Checkbox} from 'primereact/checkbox';
import GeneralUtils from "../../utils/GeneralUtils";
import {Dropdown} from 'primereact/dropdown';
import "./CourseContent.css";


const CourseContent = (props) => {
    const {data, completedData, course, accordionActiveIndex, onAccordionChange} = props;
    const [activeLecture, setActiveLecture] = useState(false);
    const [activeExam, setActiveExam] = useState(false);


    const openAsset = (asset) => {
        if (asset.assetType === 'ExternalLink') {
            // Dış link için yeni tab'da aç
            window.open(asset.externalUrl, '_blank', 'noopener,noreferrer');
        } else if (asset.assetType === 'File' || asset.assetType === 'SourceCode') {
            // Dosya için downloadUrl kullan
            window.open(asset.downloadUrl, '_blank', 'noopener,noreferrer');
        }
    }

    const start = (chapter, chapterIndex, lecture, lectureIndex) => {
        setActiveLecture(lecture.id);
        setActiveExam(null);
        //Sadece örnek kurs için eklenen kod
        if(!GeneralUtils.isNullOrEmpty(course) && course.id===1656498) {
            const videoUrl = "/ilearning-file/courses/" + course.title + "/" + Number(chapterIndex + 1) + ". " + chapter.title + "/" + Number(lectureIndex + 1)
                + ". " + lecture.title.replaceAll("/", "").replaceAll("?", "").replaceAll('"', "").replaceAll(":", "") + ".mp4";
            lecture.asset = {videoUrl: videoUrl, assetType: 'Video'};
        }
        props.onStart(chapter, lecture);
    }

    const startExam = (chapter, exam) => {
        setActiveExam(exam.id);
        setActiveLecture(null);
        props.onStartExam(chapter, exam);
    }

    const getIcon =(assetType) => {
        if (assetType === 'Video') {
            return "pi pi-video";
        } else if (assetType === 'Article') {
            return "pi pi-book";
        } else if (assetType === 'Presentation') {
            return "pi pi-file-pdf";
        } else if (assetType === 'File') {
            return "pi pi-file-pdf";
        } else if (assetType === 'ExternalLink') {
            return "pi pi-external-link";
        } else if (assetType === 'SourceCode') {
            return "pi pi-code";
        } else {
            return "pi pi-exclamation-triangle";
        }
    }

    if (!GeneralUtils.isNullOrEmpty(data)) {
        return (
                <Accordion multiple className="course-content"
                    activeIndex={accordionActiveIndex}
                    onTabChange={onAccordionChange}
                >
                    {data?.sort(GeneralUtils.compareIndex).map((chapter, chapterIndex) => {
                        const lectureList = chapter?.lectureList || [];
                        // Sınavın aktif olması için artık sadece assetType'ı 'Video' olan derslerin tamamlanmış olması yeterli.
                        const videoLectures = lectureList.filter(l => l.asset?.assetType === 'Video');
                        const allVideoLecturesCompleted = videoLectures.length === 0 || videoLectures.every(l => completedData?.includes(l.id));
                        return (
                        <AccordionTab key={chapter.id} header={
                            <>
                                {chapter.objectIndex}: {chapter.title}
                                <div className="chapter-info">{chapter.lectureList?.length} ders • {chapter.contentLengthText}</div>
                            </>}>

                            {chapter.lectureList?.sort(GeneralUtils.compareIndex).map((lecture, lectureIndex) => {
                                const isCompleted = completedData?.includes(lecture.id);
                                const isActive = lecture.id === activeLecture;
                                return (
                                <> {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <a
                                   href="#"
                                   className={`lecture${isActive ? ' active' : ''}${isCompleted ? ' completed' : ''}`}
                                   key={lecture.id}
                                   onClick={(e) => { e.preventDefault(); start(chapter, chapterIndex, lecture, lectureIndex); }}
                                >
                                    <div className="left">
                                        <Checkbox inputId="lecture" checked={isCompleted} disabled/>
                                    </div>
                                    <div className="right">
                                        <p className={isCompleted ? 'p-disabled' : ''}>{lecture.objectIndex}. {lecture.title}</p>
                                        <div className="lecture-info">
                                            <div className="duration">
                                                <i className={getIcon(lecture.asset?.assetType)} style={{ fontSize: '0.8rem'}}/>
                                                <p>{lecture.contentSummary}</p>
                                            </div>
                                            {!GeneralUtils.isNullOrEmpty(lecture.supplementaryAssets) &&
                                                <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
                                                    <Dropdown onChange={(e) => openAsset(e.value)}
                                                              options={lecture.supplementaryAssets}
                                                              optionLabel="title" placeholder="📚 Kaynaklar"
                                                              className="p-inputtext-sm"
                                                              style={{zIndex: "1002 !important"}}
                                                              itemTemplate={(option) => (
                                                                  <div className="flex align-items-center gap-2">
                                                                      <i className={getIcon(option.assetType)} style={{fontSize: '0.9rem'}}/>
                                                                      <span>{option.title}</span>
                                                                  </div>
                                                              )}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </a>
                                </>
                            )})}

                            {chapter.examList?.sort(GeneralUtils.compareIndex).map((exam) => {
                                const examDisabled = !allVideoLecturesCompleted; // Sadece video dersleri baz alınır
                                const tooltipText = "Sınavın aktif olması için bölümdeki tüm video derslerinin tamamlanması gerekmektedir";
                                const examCompleted = completedData?.includes(exam.id);
                                const isExamActive = exam.id === activeExam;
                                return (
                                <> {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <a
                                    href="#"
                                    className={`lecture exam${isExamActive ? ' active' : ''}${examCompleted ? ' completed' : ''}${examDisabled ? ' exam-disabled' : ''}`}
                                    key={exam.id}
                                    title={examDisabled ? tooltipText : undefined}
                                    onClick={(e) => { e.preventDefault(); if(!examDisabled) startExam(chapter, exam); }}
                                >
                                    <div className="left">
                                        <Checkbox inputId="lecture" checked={examCompleted} disabled/>
                                    </div>
                                    <div className={`right${examCompleted ? ' p-disabled' : ''}`}>
                                        <p>{exam.objectIndex}. {exam.title}</p>
                                    </div>
                                </a>
                                </>
                            )})}
                        </AccordionTab>
                    )})}
                </Accordion>
        );
    }
}
export default CourseContent;
